import { apiRequest } from '../../services/apiClient';

export interface OAuthConfig {
  kakaoClientId: string;
  naverClientId: string;
}

const KAKAO_REDIRECT_PATH = '/oauth/kakao/callback';
const NAVER_REDIRECT_PATH = '/oauth/naver/callback';
const NAVER_STATE_KEY = 'naverOAuthState';

function getOAuthConfig(): Promise<OAuthConfig> {
  return apiRequest<OAuthConfig>('/api/users/oauth/config');
}

export function kakaoRedirectUri(): string {
  return `${window.location.origin}${KAKAO_REDIRECT_PATH}`;
}

export function naverRedirectUri(): string {
  return `${window.location.origin}${NAVER_REDIRECT_PATH}`;
}

export async function startKakaoLogin(): Promise<void> {
  const { kakaoClientId } = await getOAuthConfig();
  const url = new URL('https://kauth.kakao.com/oauth/authorize');
  url.searchParams.set('client_id', kakaoClientId);
  url.searchParams.set('redirect_uri', kakaoRedirectUri());
  url.searchParams.set('response_type', 'code');
  window.location.href = url.toString();
}

export async function startNaverLogin(): Promise<void> {
  const { naverClientId } = await getOAuthConfig();
  const state = crypto.randomUUID();
  sessionStorage.setItem(NAVER_STATE_KEY, state);

  const url = new URL('https://nid.naver.com/oauth2.0/authorize');
  url.searchParams.set('client_id', naverClientId);
  url.searchParams.set('redirect_uri', naverRedirectUri());
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('state', state);
  window.location.href = url.toString();
}

// 콜백에서 한 번만 검증하고 즉시 폐기한다(재사용 방지)
export function consumeNaverState(): string | null {
  const state = sessionStorage.getItem(NAVER_STATE_KEY);
  sessionStorage.removeItem(NAVER_STATE_KEY);
  return state;
}
